import type { MailboxInfo } from 'owa-client-types';
import { getIndexerValueForMailboxInfo } from 'owa-client-types';

/**
 * Gets the string key for the given attendee and account
 * @param address: Attendee smtp address
 * @param mailboxInfo: Mailbox info for the requesting account
 */
export function getAttendeeKey(address: string, mailboxInfo: MailboxInfo): string {
    return address + '_' + getIndexerValueForMailboxInfo(mailboxInfo);
}
